import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-upgrade-cards',
  templateUrl: './upgrade-cards.component.html',
  styleUrls: ['./upgrade-cards.component.css']
})
export class UpgradeCardsComponent implements OnInit {

  @Input() upgradeProducts;
  @Output() upgradeAction = new EventEmitter();


  constructor() { }

  ngOnInit() {
  }

  upgrade(data) {
    this.upgradeAction.emit(data);
  }

}
